import { combineReducers } from "redux";
import GetLoader from "./main/get_loader";
import Loginstat from "./login/loginstat";
import Token from "./login/tokenx";
import GetDashboardMydata from "./dashboard/get_mydata";
import GetMenuWorkspace from "./workspace/menulist";
import GetRightPanel from "./dashboard/get_rightpanel";
import GetLeftPanel from "./dashboard/get_leftpanel";
import GetBottomPanel from "./dashboard/get_bottompanel";
import GetBottomLegendPanel from "./dashboard/get_bottomlegendpanel";
import GetCampaign from "./dashboard/get_campaign";
import GetBaseMap from "./portal/get_basemap";
import GetDateVersion from "./portal/get_dateversion";
import GetZoom from "./portal/get_zoom";
import GetLongLat from "./portal/get_longlat";
import GetCheckedPOI from "./portal/get_checked_poi";
import GetBaseMapLegend from "./portal/get_baselegend";
import GetshipFinder from "./portal/get_shipfinder";
import GetBaseMapAsli from "./portal/get_basemapasli";
import GetPoiPasenger from "./portal/get_poi_pasengger";
import GetPoiContent from "./portal/get_poi_content";
import GetMeasureStat from "./portal/get_measure_stat";
import GetLonLatMouse from "./portal/get_lonlat_mouse";
import GetDrawType from "./portal/get_draw_type";
import GetDrawdata from "./portal/get_draw_data";
import GetDrawdataall from "./portal/get_draw_data_all";
import GetPOITarget from "./portal/get_poi_target";
import GetZoneTarget from "./portal/get_zona_target";
import GetPortTarget from "./portal/get_port_target";
import GetPoiInfoExpand from "./portal/get_poi_info_expand";
import GetDistinctCheck from "./portal/get_district_checked";
import GetPointShipTrack from "./portal/get_point_ship_track";
import GetVesselPointTrack from "./portal/get_vessel_point_track";
import GetActiveDrawing from "./portal/get_list_active_drawing";
import GetActiveTracking from "./portal/get_list_active_tracking";
import GetActiveSearching from "./portal/get_list_active_search";
import GetCenterLinestring from "./portal/get_center_linestring";
import GetWorkspaceList from "./workspace/get_workspacelist";
import GetWorkspaceID from "./workspace/get_workspaceid";
import GetVesselSelected from "./portal/get_vessel_selected";
import GetLayerAdd from "./portal/get_layer_add";
import GetPoiSelected from "./portal/get_poi_selected";
import GetEarthQuake from "./portal/get_earthquake";
import GetVesselPtmChecked from "./portal/get_vessel_ptm_checked";
import GetAllStateMapmaster from "./portal/get_all_state_mapmaster";
import GetFilter from "./portal/get_filter";
import GetShipTrack from "./portal/get_ship_track";
import GetShipTrack2 from "./portal/get_ship_track2";
import GetSourceAis from "./portal/get_source_ais";
import GetWeatherChecked from "./portal/get_weather_checked";
import GetBathymetryChecked from "./portal/get_bathymetry_checked";
import GetVideoData from "./portal/get_video_data";
import GetSearchVessel from "./portal/get_search_vessel";
import GetDialogSearch from "./portal/get_dialog_search";
import GetCctvHistoris from "./dashboard/get_cctv_historis";
import GetCctvToken from "./dashboard/get_cctv_token";
import GetCctvMap from "./dashboard/get_cctv_map";
import GetShipFraud from "./portal/get_ship_fraud";
import GetSpeedTarget from "./portal/get_speed_target";

const rootReducer = combineReducers({
  activeDrawing: GetActiveDrawing,
  activeTracking: GetActiveTracking,
  activeSearching: GetActiveSearching,
  loader: GetLoader,
  loginstat: Loginstat,
  token: Token,
  dashboard_mydata: GetDashboardMydata,
  menuWorkspace: GetMenuWorkspace,
  rightPanel: GetRightPanel,
  bottomPanel: GetBottomPanel,
  bottomLegendPanel: GetBottomLegendPanel,
  campaign: GetCampaign,
  basemap: GetBaseMap,
  basemapLegend: GetBaseMapLegend,
  dateversion: GetDateVersion,
  leftPanel: GetLeftPanel,
  zoom: GetZoom,
  longlat: GetLongLat,
  checkedPOI: GetCheckedPOI,
  shipFinder: GetshipFinder,
  basemapAsli: GetBaseMapAsli,
  poiPasenger: GetPoiPasenger,
  poiContent: GetPoiContent,
  measureStat: GetMeasureStat,
  lonlatMouse: GetLonLatMouse,
  drawType: GetDrawType,
  drawData: GetDrawdata,
  poiTarget: GetPOITarget,
  zoneTarget: GetZoneTarget,
  drawDataAll: GetDrawdataall,
  portTarget: GetPortTarget,
  poiInfoExpand: GetPoiInfoExpand,
  distinctCheck: GetDistinctCheck,
  pointShipTrack: GetPointShipTrack,
  vesselPointTrack: GetVesselPointTrack,
  centerLinestring: GetCenterLinestring,
  workspaceList: GetWorkspaceList,
  workspaceID: GetWorkspaceID,
  vesselSelected: GetVesselSelected,
  layerAdd: GetLayerAdd,
  poiSelected: GetPoiSelected,
  earthQuake: GetEarthQuake,
  vesselPtmChecked: GetVesselPtmChecked,
  allStateMapmaster: GetAllStateMapmaster,
  filter: GetFilter,
  shipTrack: GetShipTrack,
  shipTrack2: GetShipTrack2,
  sourceAis: GetSourceAis,
  weatherChecked: GetWeatherChecked,
  bathymetryChecked: GetBathymetryChecked,
  videoData: GetVideoData,
  searchVessel: GetSearchVessel,
  dialogSearch: GetDialogSearch,
  cctvHistoris: GetCctvHistoris,
  cctvMap: GetCctvMap,
  cctvToken: GetCctvToken,
  shipFraud: GetShipFraud,
  speedTarget: GetSpeedTarget
});

export default rootReducer;
